import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Waveform from "@/components/Waveform";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="forgot-password-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md">
        <p className="eyebrow mb-3">Locked out?</p>
        <h1 className="font-anton uppercase text-5xl sm:text-6xl leading-none mb-8">Reset Password</h1>
        <Waveform color="rgb(var(--graphite))" className="mb-10" />
        {sent ? (
          <div data-testid="forgot-success">
            <p className="text-chalk/80 leading-relaxed">
              If an account exists for <span className="text-signal font-mono">{email}</span>, a reset link is on its way. Check your inbox — the link expires in 1 hour.
            </p>
            <Link to="/login" className="btn-pulse inline-flex mt-10" data-testid="back-to-login">Back to Sign In</Link>
          </div>
        ) : (
          <>
            <p className="text-graphite text-sm mb-8">Enter your email and we'll send you a secure link to reset your password.</p>
            <form onSubmit={submit} className="space-y-6" data-testid="forgot-form">
              <div>
                <label className="eyebrow block mb-2">Email</label>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"
                  className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
              </div>
              {error && <p className="text-destructive font-mono text-xs" data-testid="forgot-error">{error}</p>}
              <button type="submit" disabled={loading} data-testid="forgot-submit" className="btn-pulse w-full disabled:opacity-60">
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
            <p className="mt-8 text-graphite text-sm font-mono">
              Remembered it? <Link to="/login" className="text-chalk hover:text-pulse link-underline">Sign in</Link>
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}
